import { clamp } from 'lodash';

export { clamp };

export const lerp = (from: number, to: number, alpha: number) => from + ((to - from) * alpha);
